import type { SbBlokData } from '@cinch-nx/data-storyblok'

import { Badge as DsBadge, type BadgeProps } from '../../design-system/badge'

/** Storyblok sends '' for a Single-Option left empty */
type Option<T> = T | ''

/** '' would skip the Badge defaults, so it becomes undefined */
const orDefault = <T,>(value?: Option<T>) => value || undefined

/** Fields of the DS_Badge blok; the option values match the Badge props */
export interface BadgeBlok extends SbBlokData {
  /** Required in Storyblok, but content saved before a rule change can lack it */
  text?: string
  icon?: Option<BadgeProps['icon']>
  iconPosition?: Option<BadgeProps['iconPosition']>
  variant?: Option<BadgeProps['variant']>
  size?: Option<BadgeProps['size']>
  shape?: Option<BadgeProps['shape']>
}

export const Badge = ({
  text,
  icon,
  iconPosition,
  variant,
  size,
  shape,
}: BadgeBlok) => (
  <DsBadge
    text={text ?? ''}
    icon={orDefault(icon)}
    iconPosition={orDefault(iconPosition)}
    variant={orDefault(variant)}
    size={orDefault(size)}
    shape={orDefault(shape)}
  />
)
